import { defineStore } from 'pinia';
import { queryPsdImportConfig, querySettingInfo } from '../api/common';
import type { API } from '../types';

const defaultPsdImportConfig: API.PsdImportConfig = {
  example_url: '',
  psd_engine_url: '',
  max_source_mb: 150,
  max_layer_count: 300,
  engine_export_timeout_seconds: 60,
};

export const useSettingStore = defineStore('setting', {
  state: () => ({
    settingInfo: {} as API.Setting,
    psdImportConfig: { ...defaultPsdImportConfig } as API.PsdImportConfig,
  }),
  actions: {
    async getSettingInfo() {
      this.settingInfo = await querySettingInfo();
    },
    async getPsdImportConfig() {
      try {
        const config = await queryPsdImportConfig();
        this.psdImportConfig = {
          ...defaultPsdImportConfig,
          ...config,
          max_source_mb: config.max_source_mb && config.max_source_mb > 0 ? config.max_source_mb : defaultPsdImportConfig.max_source_mb,
          max_layer_count: config.max_layer_count && config.max_layer_count > 0 ? config.max_layer_count : defaultPsdImportConfig.max_layer_count,
          engine_export_timeout_seconds: config.engine_export_timeout_seconds && config.engine_export_timeout_seconds > 0
            ? config.engine_export_timeout_seconds
            : defaultPsdImportConfig.engine_export_timeout_seconds,
        };
      } catch {
        this.psdImportConfig = { ...defaultPsdImportConfig };
      }
    },
  },
});
